import { render } from "./hconfig.vue?vue&type=template&id=93dcc70e&scoped=true"
const script = {}

import "./hconfig.vue?vue&type=style&index=0&id=93dcc70e&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93dcc70e"]])

export default __exports__